import React from 'react';
/**
 * Returns all children that are valid elements as an array.
 * Can optionally be filtered by passing a predicate.
 * @param {ReactNode} children
 * @param {function => boolean} predicate
 * @return {ReactElement[]}
 */

export default function getChildrenElements(children) {
  var predicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  return React.Children.toArray(children).filter(function (child) {
    return /*#__PURE__*/React.isValidElement(child) && predicate(child);
  });
}